var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.07 8.57998C22.2661 8.48002 22.4549 8.3664 22.635 8.23998C24.095 7.21498 24.545 5.32998 23.635 4.03998C22.725 2.74998 20.805 2.53998 19.345 3.57498C17.885 4.60998 17.135 6.43998 16.32 8.57498L22.07 8.57998ZM4.35001 15.23H27.655V27.08C27.655 27.6104 27.4443 28.1191 27.0692 28.4942C26.6941 28.8693 26.1854 29.08 25.655 29.08H6.35001C5.81957 29.08 5.31087 28.8693 4.93579 28.4942C4.56072 28.1191 4.35001 27.6104 4.35001 27.08V15.23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.925 15.23H13.075V29.08H18.925V15.23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92999 8.57998C9.73492 8.48111 9.54771 8.36744 9.36999 8.23998C7.90999 7.21498 7.45499 5.32998 8.36999 4.03998C9.28499 2.74998 11.2 2.53998 12.665 3.57498C14.13 4.60998 14.87 6.43998 15.69 8.57498L9.92999 8.57998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 8.58002H4.75C3.92157 8.58002 3.25 9.25159 3.25 10.08V13.73C3.25 14.5584 3.92157 15.23 4.75 15.23H27.25C28.0784 15.23 28.75 14.5584 28.75 13.73V10.08C28.75 9.25159 28.0784 8.58002 27.25 8.58002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.46 8.58002H12.545V15.23H19.46V8.58002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/reward-icon.0e6c1c7dc252f3125addcc8df668d491.svg";
export { ForwardRef as ReactComponent };